import { i18n } from '../utils/I18n.js';

export class VictoryModal {
    constructor(onRestart, onHome, onShowLeaderboard) {
        this.container = null;
        this.onRestart = onRestart;
        this.onHome = onHome;
        this.onShowLeaderboard = onShowLeaderboard;
    }

    create() {
        let modal = document.getElementById('victoryModal');

        if (modal) {
            this.container = modal;
            // Update event listeners by cloning and replacing nodes to remove old listeners
            const btnPlayAgain = document.getElementById('btnPlayAgain');
            const btnHome = document.getElementById('btnHome');
            const btnLeaderboard = document.getElementById('btnLeaderboard');

            const newBtnPlayAgain = btnPlayAgain.cloneNode(true);
            const newBtnHome = btnHome.cloneNode(true);
            const newBtnLeaderboard = btnLeaderboard ? btnLeaderboard.cloneNode(true) : null;

            btnPlayAgain.parentNode.replaceChild(newBtnPlayAgain, btnPlayAgain);
            btnHome.parentNode.replaceChild(newBtnHome, btnHome);
            if (btnLeaderboard && newBtnLeaderboard) {
                btnLeaderboard.parentNode.replaceChild(newBtnLeaderboard, btnLeaderboard);
            }

            this.bindEvents(newBtnPlayAgain, newBtnHome, newBtnLeaderboard);
            return;
        }

        modal = document.createElement('div');
        modal.id = 'victoryModal';
        modal.innerHTML = `
            <div class="victory-modal-content">
                <div class="victory-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/>
                    </svg>
                </div>
                <h2 class="victory-title" data-i18n="victory.title">Puzzle Completed!</h2>
                <p class="victory-subtitle" data-i18n="victory.subtitle">Great job! You did it!</p>
                <div class="victory-stats">
                    <div class="stat-card">
                        <div class="stat-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                            </svg>
                        </div>
                        <div class="stat-info">
                            <span class="stat-label" data-i18n="victory.time">Time</span>
                            <span class="stat-value" id="victoryTime">00:00</span>
                        </div>
                    </div>
                    <div class="stat-card">
                        <div class="stat-icon score-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                            </svg>
                        </div>
                        <div class="stat-info">
                            <span class="stat-label" data-i18n="victory.score">Score</span>
                            <span class="stat-value" id="victoryScore">0</span>
                        </div>
                    </div>
                </div>
                <div class="victory-actions">
                    <button id="btnPlayAgain" class="victory-btn victory-btn-primary">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
                        </svg>
                        <span data-i18n="victory.play_again">Play Again</span>
                    </button>
                    <button id="btnLeaderboard" class="victory-btn victory-btn-secondary" style="background: #E8A598;">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M16 11V3H8v6H2v12h20V11h-6zm-6-6h4v14h-4V5zm-6 6h4v8H4v-8zm16 8h-4v-6h4v6z"/>
                        </svg>
                        <span data-i18n="victory.rankings">Rankings</span>
                    </button>
                    <button id="btnHome" class="victory-btn victory-btn-secondary">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                        </svg>
                        <span data-i18n="victory.back_home">Back Home</span>
                    </button>
                </div>
            </div>
        `;

        // Styles - Modern Dark Overlay Theme
        const style = document.createElement('style');
        style.id = 'victory-modal-styles';
        // ... (保持原有样式不变，或者添加 btnLeaderboard 的特定样式，这里内联style已经处理了颜色)
        style.textContent = `
            @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap');
            /* ... 原有 CSS ... */
            #victoryModal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.7); 
                backdrop-filter: blur(8px);
                -webkit-backdrop-filter: blur(8px);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 2000;
                opacity: 0;
                transition: opacity 0.4s ease;
                display: none;
                pointer-events: none;
            }

            #victoryModal.visible {
                opacity: 1;
                pointer-events: auto;
            }

            .victory-modal-content {
                font-family: 'Quicksand', sans-serif;
                background: transparent;
                padding: 40px;
                text-align: center;
                box-shadow: none;
                border: none;
                transform: scale(0.85) translateY(20px);
                transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                position: relative;
                overflow: visible;
                max-width: 600px; /* Increased max-width */
                width: 90%;
            }

            #victoryModal.visible .victory-modal-content {
                transform: scale(1) translateY(0);
            }

            .victory-icon {
                width: 96px;
                height: 96px;
                margin: 0 auto 24px;
                background: none;
                display: flex;
                align-items: center;
                justify-content: center;
                filter: drop-shadow(0 0 20px rgba(246, 211, 101, 0.6));
                animation: icon-bounce 0.6s ease-out;
            }

            @keyframes icon-bounce {
                0% { transform: scale(0); }
                50% { transform: scale(1.2); }
                100% { transform: scale(1); }
            }

            .victory-icon svg {
                width: 56px;
                height: 56px;
                background: linear-gradient(135deg, #F6D365 0%, #E8A598 100%);
                -webkit-mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/></svg>');
                mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/></svg>');
                -webkit-mask-repeat: no-repeat;
                mask-repeat: no-repeat;
                -webkit-mask-size: contain;
                mask-size: contain;
                fill: none;
            }

            .victory-title {
                font-size: 3rem;
                font-weight: 800;
                background: linear-gradient(135deg, #F6D365 0%, #FDA085 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                color: transparent;
                margin-bottom: 12px;
                filter: drop-shadow(0 4px 12px rgba(253, 160, 133, 0.3));
            }

            .victory-subtitle {
                font-size: 1.1rem;
                color: rgba(255, 255, 255, 0.8);
                margin-bottom: 40px;
            }

            .victory-stats {
                display: flex;
                gap: 20px;
                justify-content: center;
                margin-bottom: 48px;
            }

            .stat-card {
                background: rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(10px);
                padding: 16px 24px;
                border-radius: 20px;
                display: flex;
                align-items: center;
                gap: 12px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
                border: 1px solid rgba(255, 255, 255, 0.15);
                min-width: 140px;
            }

            .stat-icon {
                width: 44px;
                height: 44px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
            }

            .stat-icon.score-icon {
                background: rgba(255, 255, 255, 0.2);
            }

            .stat-icon svg {
                width: 22px;
                height: 22px;
                fill: white;
            }

            .stat-info {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            }

            .stat-label {
                font-size: 0.85rem;
                color: rgba(255, 255, 255, 0.6);
                font-weight: 500;
                text-transform: uppercase;
                letter-spacing: 0.5px;
            }

            .stat-value {
                font-size: 1.4rem;
                font-weight: 700;
                color: #FFFFFF;
            }

            .victory-actions {
                display: flex;
                gap: 16px;
                justify-content: center;
                flex-wrap: wrap; /* Allow wrapping on small screens */
            }

            .victory-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                padding: 16px 24px; /* Slightly reduced padding */
                border: none;
                border-radius: 50px;
                font-family: 'Quicksand', sans-serif;
                font-size: 1rem; /* Slightly reduced font size */
                font-weight: 700;
                cursor: pointer;
                transition: all 0.3s ease;
                white-space: nowrap;
            }

            .victory-btn svg {
                width: 20px;
                height: 20px;
            }

            .victory-btn-primary {
                background: #FFFFFF;
                color: #E07A6B;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            }

            .victory-btn-primary:hover {
                transform: translateY(-3px) scale(1.05);
                box-shadow: 0 8px 30px rgba(255, 255, 255, 0.3);
            }

            .victory-btn-secondary {
                background: linear-gradient(135deg, #FDA085 0%, #E07A6B 100%);
                color: #FFFFFF;
                border: none;
                box-shadow: 0 4px 20px rgba(224, 122, 107, 0.3);
            }

            .victory-btn-secondary:hover {
                transform: translateY(-3px);
                box-shadow: 0 8px 28px rgba(224, 122, 107, 0.4);
                filter: brightness(1.1);
            }

            @media (max-width: 600px) {
                .victory-modal-content {
                    padding: 20px;
                    width: 95%;
                }

                .victory-stats {
                    flex-direction: column;
                    gap: 12px;
                }

                .stat-card {
                    justify-content: center;
                    width: 100%;
                }

                .victory-actions {
                    flex-direction: column;
                    width: 100%;
                }

                .victory-btn {
                    width: 100%;
                }
            }
        `;

        document.head.appendChild(style);
        document.body.appendChild(modal);
        this.container = modal;

        this.bindEvents(
            document.getElementById('btnPlayAgain'),
            document.getElementById('btnHome'),
            document.getElementById('btnLeaderboard')
        );
    }

    bindEvents(btnPlayAgain, btnHome, btnLeaderboard) {
        btnPlayAgain.addEventListener('click', () => {
            this.hide();
            if (this.onRestart) this.onRestart();
        });

        btnHome.addEventListener('click', () => {
            this.hide();
            if (this.onHome) this.onHome();
        });

        if (btnLeaderboard) {
            btnLeaderboard.addEventListener('click', () => {
                // Keep victory modal open or close it? usually nice to keep it or just stack
                // But for simplicity, we might close it or just show LB over it.
                // Let's close it.
                this.hide();
                if (this.onShowLeaderboard) this.onShowLeaderboard();
            });
        }
    }

    show(time, score) {
        if (!this.container) this.create();

        // Ensure container is valid
        if (!this.container) return;

        document.getElementById('victoryTime').textContent = time;
        document.getElementById('victoryScore').textContent = score;

        this.container.style.display = 'flex';
        // Force reflow
        this.container.offsetHeight;
        this.container.classList.add('visible');

        // Apply i18n translations
        i18n.applyTranslations();
    }

    hide() {
        if (!this.container) return;
        this.container.classList.remove('visible');
        this.container.style.display = 'none';
        // Ensure opacity is reset for next show
        this.container.style.opacity = '';
    }
}
